<template>
  <div class="w-full flex justify-center af-automate-wrapper gm-automation-v2-flow">
    <div
      v-if="triggersFetched && conditionsFetched && actionsFetched"
      class="w-full flex gm-automation-v2-flow__columns"
    >
      <div class="flex flex-col gm-automation-v2-flow__column" style="width: 30%">
        <automations-node
          class="relative w-full py-4 px-6 gm-automation-v2-flow__heading"
          style="max-width: 420px; margin: 0px auto"
          :headerNode="true"
          type="trigger"
          :stepCount="1"
        >
        </automations-node>
        <VuePerfectScrollbar
          class="flex w-full pt-5 gm-automation-v2-flow__scroll"
          style="height: 100vh; max-height: calc(100vh - 200px)"
        >
          <div
            :key="getUniqueKey(0)"
            class="relative w-full px-6 gm-automation-v2-flow__node-wrap"
            v-if="automationHasData"
          >
            <automations-node
              class="relative py-4 rounded-lg bg-white gm-automation-v2-flow__node-card"
              style="
                box-shadow: 0px 4px 4px rgba(22, 29, 37, 0.04);
                max-width: 420px;
                margin: 0px auto;
              "
              :automationFiltersData="automationsData[0]"
              type="trigger"
              :autoFilterIndex="0"
              @editAutomationNode="editAutomationNode"
              @deleteAutomationNode="deleteAutomationNodeModal"
            >
            </automations-node>
          </div>
          <div
            class="flex justify-center bg-grey-100 mt-4 mb-6 w-full px-6 gm-automation-v2-flow__add-wrap"
            v-if="!automationHasData"
          >
            <gd-button
              class="gm-automation-v2-flow__add-control"
              @click="addNewAutomationOption(0, 'trigger')"
              ><span class="font-bold mr-4 text-xl">+</span
              >{{
                $t(
                  'frontend_groovemail_automations_start_adding_triggers_btn_text'
                )
              }}</gd-button
            >
          </div>
        </VuePerfectScrollbar>
      </div>

      <div class="pt-40 flex items-center h-0 gm-automation-v2-flow__connector" style="width: 5%">
        <div
          class="border border-dashed w-full"
          style="border-color: #a4a8c0"
        ></div>
        <div class="af-connector-arrow af-connector-arrow-right"></div>
      </div>

      <div
        class="flex flex-col gm-automation-v2-flow__column"
        style="width: 30%"
        :class="{ 'opacity-5 cursor-not-allowed': !automationHasData }"
      >
        <automations-node
          class="relative w-full py-4 px-6 gm-automation-v2-flow__heading"
          style="max-width: 420px; margin: 0px auto"
          :headerNode="true"
          type="condition"
          :stepCount="2"
        >
        </automations-node>
        <VuePerfectScrollbar
          class="flex flex-col w-full pt-5 gm-automation-v2-flow__scroll"
          style="max-height: calc(100vh - 200px)"
        >
          <div
            v-for="(automationFilter, index) in condAutomationsData"
            :key="getUniqueKey(index + 1)"
            class="relative w-full px-6 gm-automation-v2-flow__node-wrap"
          >
            <automations-node
              class="py-4 rounded-lg bg-white gm-automation-v2-flow__node-card"
              style="
                box-shadow: 0px 4px 4px rgba(22, 29, 37, 0.04);
                max-width: 420px;
                margin: 0px auto;
              "
              :automationFiltersData="automationFilter"
              type="condition"
              :autoFilterIndex="index + 1"
              @editAutomationNode="editAutomationNode"
              @deleteAutomationNode="deleteAutomationNodeModal"
            ></automations-node>
            <div v-if="index < condAutomationsData.length - 1">
              <div class="relative">
                <div class="af-btn-connector-before"></div>
              </div>
              <div class="flex justify-center bg-grey-100 my-6">
                <gd-button
                  primmary
                  class="h-10 af-plus-btn gm-automation-v2-flow__plus-control"
                  @click="addNewAutomationOption(index + 1, 'condition')"
                ></gd-button>
              </div>
              <div
                class="relative"
                v-if="index < condAutomationsData.length - 1"
              >
                <div class="af-btn-connector-after"></div>
              </div>
            </div>
          </div>
          <div
            v-if="
              !conditionsEnabledAndAdded &&
              skipConditions &&
              condAutomationsData &&
              condAutomationsData.length === 0
            "
            class="flex justify-center items-center h-16"
            @click="
              addNewAutomationOption(condAutomationsData.length, 'condition')
            "
          >
            <p class="text-primary cursor-pointer font-bold">
              {{
                $t(
                  'frontend_groovemail_automations_enabling_conditions_btn_text'
                )
              }}
            </p>
          </div>
          <div class="flex justify-center bg-grey-100 mt-4 mb-6 px-6 gm-automation-v2-flow__add-wrap" v-else>
            <gd-button
              :class="{
                'cursor-not-allowed text-grey-500': !automationHasData,
                'text-grey-700': automationHasData,
              }"
              size="iconlg"
              class="gm-automation-v2-flow__add-control"
              :disabled="!automationHasData"
              @click="addNewAutomationOption(condAutomationsData.length, 'condition')">
                <PlusIcon class="w-6 h-6" />
                {{ $t('frontend_groovemail_automations_start_adding_constions_btn_text') }}
              </gd-button>
          </div>
          <div
            class="flex justify-center"
            v-if="
              !skipConditions &&
              !(condAutomationsData && condAutomationsData.length)
            "
            @click="skipToActions"
          >
            <p
              class="text-primary cursor-pointer"
              :class="{ 'cursor-not-allowed': !automationHasData }"
            >
              {{ $t('frontend_groovemail_automations_new_ui_skip_label') }}
            </p>
          </div>
        </VuePerfectScrollbar>
      </div>

      <div class="pt-40 flex items-center h-0 gm-automation-v2-flow__connector" style="width: 5%">
        <div
          class="border border-dashed w-full"
          style="border-color: #a4a8c0"
        ></div>
        <div class="af-connector-arrow af-connector-arrow-right"></div>
      </div>

      <div
        class="flex flex-col gm-automation-v2-flow__column"
        style="width: 30%"
        :class="{
          'opacity-5 cursor-not-allowed':
            !skipConditions &&
            !(condAutomationsData && condAutomationsData.length),
        }"
      >
        <automations-node
          class="relative w-full py-4 px-6 gm-automation-v2-flow__heading"
          style="max-width: 420px; margin: 0px auto"
          :headerNode="true"
          type="action"
          :stepCount="3"
        >
        </automations-node>
        <VuePerfectScrollbar
          class="flex flex-col w-full pt-5 gm-automation-v2-flow__scroll"
          style="max-height: calc(100vh - 200px)"
        >
          <div
            v-for="(automationFilter, index) in actionAutomationsData"
            :key="getUniqueKey(condAutomationsData.length + index + 1)"
            class="relative w-full px-6 gm-automation-v2-flow__node-wrap"
          >
            <automations-node
              class="py-4 rounded-lg bg-white gm-automation-v2-flow__node-card"
              style="
                box-shadow: 0px 4px 4px rgba(22, 29, 37, 0.04);
                max-width: 420px;
                margin: 0px auto;
              "
              :automationFiltersData="automationFilter"
              type="action"
              :autoFilterIndex="condAutomationsData.length + index + 1"
              @editAutomationNode="editAutomationNode"
              @deleteAutomationNode="deleteAutomationNodeModal"
            ></automations-node>
            <div v-if="index < actionAutomationsData.length - 1">
              <div class="relative">
                <div class="af-btn-connector-before"></div>
              </div>
              <div class="flex justify-center bg-grey-100 my-6">
                <gd-button
                  variant="primary"
                  class="h-10 af-plus-btn gm-automation-v2-flow__plus-control"
                  @click="
                    addNewAutomationOption(
                      condAutomationsData.length + index + 1,
                      'action'
                    )
                  "
                ></gd-button>
              </div>
              <div
                class="relative"
                v-if="index < actionAutomationsData.length - 1"
              >
                <div class="af-btn-connector-after"></div>
              </div>
            </div>
          </div>
          <div class="flex justify-center bg-grey-100 mt-4 mb-6 px-6 gm-automation-v2-flow__add-wrap">
            <gd-button
              :class="{
                'cursor-not-allowed text-grey-500':
                  !skipConditions &&
                  !(condAutomationsData && condAutomationsData.length),
                'text-grey-700':
                  skipConditions ||
                  (condAutomationsData && condAutomationsData.length),
              }"
              :disabled="
                !skipConditions &&
                !(condAutomationsData && condAutomationsData.length)
              "
              class="gm-automation-v2-flow__add-control"
              @click="
                addNewAutomationOption(
                  condAutomationsData.length + actionAutomationsData.length,
                  'action'
                )
              "
              ><span class="font-bold mr-4 text-xl">+</span
              >{{
                $t(
                  'frontend_groovemail_automations_start_adding_actions_btn_text'
                )
              }}</gd-button
            >
          </div>
        </VuePerfectScrollbar>
      </div>
    </div>
    <gd-modal
      id="automation-node-modal"
      class="automations-ui-node-modal"
      name="automation-node-modal"
      :title="
        this.$t('frontend_groovemail_automations_enter_name_for_automation')
      "
    >
      <div class="pb-6">
        <automation-filters
          :autoType="automationNode.config ? 'edit' : 'add'"
          :filters="fetchFilters(automationNode)"
          :type="automationNode.type"
          :autoFilterIndex="currentlySelectedPosition"
          :automationFiltersData="automationNode"
          @showLoader="showLoader()"
          @hideLoader="hideLoader()"
          @filterDataChanged="filterDataChanged"
          @closeAutomationNodeModal="closeAutomationNodeModal"
        ></automation-filters>
      </div>
    </gd-modal>


    <!-- Delete Automation Node Confirmation Modal -->
    <confirm-modal
      :ref="`confirmation-delete-automationNode`"
      :name="`confirmation-delete-automationNode`"
      :buttonText="$t('frontend_delete')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="this.$t('frontend_groovemail_automations_remove_node_confirmation_label')"
      @confirm="deleteAutomationNode"
      @cancel="closeDeleteAutomationNodeModal"
    />
  </div>
</template>

<script>
import axios from 'axios';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import AutomationsNode from '@/components/automations-v2/automations-node.vue';
import AutomationFilters from '@/components/automations-v2/automation-filters.vue';

// import icons
import PlusIcon from '@/assets/images/icons/new/plus-small_new.svg';

export default {
  middleware: 'auth',
  name: 'automate',

  props: {
    appName: {
      required: true,
    },
    preAutomationsData: {
      required: true,
    },
    postAutomationsData: {
      required: true,
    },
  },

  data() {
    return {
      triggers: [],
      triggersFetched: false,
      conditions: [],
      conditionsFetched: false,
      actions: [],
      actionsFetched: false,
      automationsData: [],
      currentlySelectedPosition: -1,
      filterType: 'condition',
      automationNode: {},
      skipConditions: false,
      conditionsEnabledAndAdded: false,
      automationNodeId: null,
    };
  },

  async created() {
    await this.fetchTriggers();
    await this.fetchConditions();
    await this.fetchActions();
    this.setFetchedAutomationsData();
  },

  computed: {
    automationHasData() {
      return (this.automationsData && this.automationsData.length) || false;
    },

    condAutomationsData() {
      const conditionsData = [];
      this.automationsData.forEach((ele) => {
        if (ele.type === 'condition') {
          conditionsData.push(ele);
        }
      });
      return conditionsData;
    },

    actionAutomationsData() {
      const actionssData = [];
      this.automationsData.forEach((ele) => {
        if (ele.type === 'action') {
          actionssData.push(ele);
        }
      });
      return actionssData;
    },

    filter_radio_options() {
      return [
        {
          id: 'condition',
          title: this.$t(
            'frontend_groovemail_automations_condition_option_label'
          ),
          description: this.$t(
            'frontend_groovemail_automations_filter_node_condition_sub_heading'
          ),
          placeholder: '',
        },
        {
          id: 'action',
          title: this.$t('frontend_groovemail_automations_action_option_label'),
          description: this.$t(
            'frontend_groovemail_automations_filter_node_action_sub_heading'
          ),
          placeholder: '',
        },
      ];
    },
  },

  methods: {
    showLoader() {
      this.$emit('showLoader');
    },

    hideLoader() {
      this.$emit('hideLoader');
    },

    fetchFilters(filter) {
      let filters;
      if (filter.type === 'trigger') {
        filters = this.triggers;
      } else if (filter.type === 'condition') {
        filters = this.conditions;
      } else if (filter.type === 'action') {
        filters = this.actions;
      }
      return filters;
    },

    async fetchTriggers() {
      this.showLoader();
      try {
        const requestParams = {
          app_name: this.appName,
        };
        const triggers = await axios.get('/automation_v2/dropdown/triggers', {
          params: requestParams,
        });
        this.triggers = triggers.data.data ? triggers.data.data : [];
        this.triggersFetched = true;
        this.hideLoader();
      } catch (err) {
        this.hideLoader();
      }
    },

    async fetchConditions() {
      this.showLoader();
      try {
        const requestParams = {
          app_name: this.appName,
        };
        const conditions = await axios.get(
          `/automation_v2/dropdown/conditions`,
          {
            params: requestParams,
          }
        );
        this.conditions = conditions.data.data ? conditions.data.data : [];
        this.conditionsFetched = true;
        this.hideLoader();
      } catch (err) {
        this.hideLoader();
      }
    },

    async fetchActions() {
      this.showLoader();
      try {
        const requestParams = {
          app_name: this.appName,
        };
        const actions = await axios.get('/automation_v2/dropdown/actions', {
          params: requestParams,
        });
        this.actions = actions.data.data ? actions.data.data : [];
        this.actionsFetched = true;
        this.hideLoader();
      } catch (err) {
        this.hideLoader();
      }
    },

    setFetchedAutomationsData() {
      if (this.preAutomationsData && this.preAutomationsData.length) {
        for (let i = 0; i < this.preAutomationsData.length; i++) {
          const autoObj = { ...this.preAutomationsData[i] };
          if (i === 0) {
            autoObj.type = 'trigger';
            autoObj.filterValid = true;
            autoObj.saved = autoObj.saved ? autoObj.saved : 0;
          } else {
            autoObj.type = 'condition';
            autoObj.filterValid = true;
            autoObj.saved = autoObj.saved ? autoObj.saved : 0;
            this.conditionsEnabledAndAdded = true;
          }
          this.automationsData.push(autoObj);
        }
      }
      if (this.postAutomationsData && this.postAutomationsData.length) {
        for (let i = 0; i < this.postAutomationsData.length; i++) {
          const autoObj = { ...this.postAutomationsData[i] };
          autoObj.type = 'action';
          autoObj.filterValid = true;
          autoObj.saved = autoObj.saved ? autoObj.saved : 0;
          this.automationsData.push(autoObj);
        }
        this.skipToActions();
      }
    },

    addNewAutomationOption(index, type) {
      this.currentlySelectedPosition = type === 'trigger' ? index : index + 1;
      this.insertNewAutomationFilter(type);
    },

    insertNewAutomationFilter(type) {
      if (type === 'condition') {
        this.automationNode = {
          type,
          filterValid: false,
          isNegative: false,
          saved: 0,
        };
      } else {
        this.automationNode = {
          type,
          filterValid: false,
          saved: 0,
        };
      }
      this.openAutomationNodeModal();
    },

    openAutomationNodeModal() {
      this.$root.$emit('modal-open', 'automation-node-modal');
    },

    closeAutomationNodeModal() {
      this.$root.$emit('modal-close', 'automation-node-modal');
    },

    filterDataChanged(filterData, index, autoType) {
      if (filterData.type === 'condition' && !this.conditionsEnabledAndAdded) {
        this.conditionsEnabledAndAdded = true;
      }
      if (autoType === 'edit') {
        this.automationsData.splice(index, 1);
      }
      this.automationsData.splice(index, 0, { ...filterData });
      this.closeAutomationNodeModal();
    },

    editAutomationNode(filterIndex) {
      this.currentlySelectedPosition = filterIndex;
      this.automationNode = { ...this.automationsData[filterIndex] };
      this.openAutomationNodeModal();
    },

    // open delete automationNode modal
    async deleteAutomationNodeModal(id) {
      // set the automationNode id
      this.automationNodeId = id;

      // open the modal
      this.$refs[`confirmation-delete-automationNode`].open();
    },

    // close delete automationNode modal
    closeDeleteAutomationNodeModal() {
      // reset the automationNode id
      this.automationNodeId = null;

      // close the modal
      this.$refs[`confirmation-delete-automationNode`].close();
    },

    // delete automationNode
    async deleteAutomationNode() {
      this.automationsData.splice(this.automationNodeId, 1);
    },

    fetchAutomationsFilterData() {
      return this.automationsData;
    },

    getUniqueKey(index) {
      return `${Math.floor(Math.random() * 90000) + 10000}-${index}`;
    },

    skipToActions() {
      if (this.automationHasData) {
        this.skipConditions = true;
      }
    },
  },

  components: {
    AutomationsNode,
    AutomationFilters,
    VuePerfectScrollbar,
    PlusIcon
  },
};
</script>

<style lang="scss">
.af-automate-wrapper {
  .opacity-5 {
    opacity: 0.5;
  }

  .af-connector-arrow {
    display: block;
    width: 0px;
    height: 0px;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-left: 16px solid #a4a8c0;
  }

  .af-connector-arrow.af-connector-arrow-right {
    border-left-color: #a4a8c0;
    border-right-width: 0px;
  }
}

.af-plus-btn {
  background-color: #989ab2 !important;
  border-color: #989ab2 !important;
  width: 24px !important;
  height: 24px !important;
  border: 1px solid #fff;
  border-radius: 50% !important;
  position: relative;
  &:before,
  &:after {
    content: '';
    display: block;
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &:before {
    height: 12px;
    width: 2px;
  }

  &:after {
    height: 2px;
    width: 12px;
  }
}

.af-plus-btn-light {
  opacity: 0.4;
  &:hover {
    opacity: 1;
  }
}

.af-btn-connector-before,
.af-btn-connector-after {
  &:before {
    content: '';
    display: block;
    border: 1px dashed #989ab2;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &:before {
    height: 16px;
    width: 2px;
  }
}

.af-btn-connector-before {
  &:before {
    top: -8px;
  }
}

.af-btn-connector-after {
  &:before {
    top: -18px;
  }
}

.af-filter-identifier {
  top: -18px;
  left: -18px;
}

.automations-ui-node-modal {
  .bg-white.rounded-lg.shadow-2xl.relative.flex.flex-col.overflow-hidden {
    overflow: unset;
    .border-solid.border-b.border-grey-200.h-16.w-full {
      display: none;
    }
  }
}
</style>

<style lang="scss" scoped>
.gm-automation-v2-flow {
  color: var(--gs-foreground);

  &__heading { min-height: 5.5rem; color: var(--gs-foreground); }
  &__node-card { border: 1px solid var(--gs-border); border-radius: var(--gs-radius-md); box-shadow: var(--gs-shadow-sm) !important; }
  &__scroll { min-width: 0; }
  &__add-wrap { background: transparent; }
  &__add-control {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    width: auto !important;
    min-width: max-content !important;
    min-height: 2.75rem;
    max-width: 100%;
    padding: 0.625rem 1rem !important;
    white-space: normal;
    text-align: left;
  }
  &__add-control > span { margin-right: 0 !important; }

  ::v-deep .gm-automation-v2-flow__plus-control {
    min-width: 2.75rem;
    min-height: 2.75rem;
    width: 2.75rem !important;
    height: 2.75rem !important;
    background-color: var(--gs-muted-foreground) !important;
    border-color: var(--gs-muted-foreground) !important;
  }

  @media (max-width: 40rem) {
    &__columns { flex-direction: column; gap: 1rem; }
    &__column { width: 100% !important; }
    &__heading { min-height: 0; padding: 0.75rem 1rem !important; }
    &__scroll { max-height: none !important; height: auto !important; overflow: visible !important; padding-top: 0.5rem !important; }
    &__node-wrap, &__add-wrap { padding-right: 1rem !important; padding-left: 1rem !important; }
    &__connector {
      width: 100% !important;
      height: 1.5rem !important;
      padding-top: 0 !important;
      flex-direction: column;
      justify-content: center;
    }
    &__connector > div:first-child {
      width: 0 !important;
      height: 0.75rem;
      border-width: 0 0 0 1px !important;
      border-left-color: var(--gs-border-strong) !important;
    }
    &__connector > .af-connector-arrow {
      transform: rotate(90deg);
      flex: 0 0 auto;
    }
    &__add-control { width: 100% !important; min-width: 0 !important; min-height: 2.75rem; line-height: 1.25; }
  }
}
</style>
